(function () {

    'use strict';

    if (typeof window === 'undefined') {

        post(
            module.exports,
            require('backbone'),
            require('lodash')
        );

    } else {

        post(
            RivalIQ.models,
            window.Backbone,
            window._
        );
    }

    function post(models, Backbone, _) {

        models.Post = Backbone.Model.extend({
            initialize: function (attributes, options) {
                const me = this;
                _.extend(me, _.pick(options, 'companyData'));
            },

            getCompany: function () {
                const me = this;
                const companyData = me.companyData;

                if (!companyData) {
                    return;
                }

                const companyId = me.get('company_id');
                const company = companyData.get(companyId);

                return company;
            },

            getChannel: function () {
                const me = this;
                const source = me.get('source');
                const channel = RivalIQ.data.channels.get(source);
                return channel;
            },

            toJSON: function () {
                const me = this;
                const source = me.get('source');

                const company = me.getCompany();
                let presence = me.get('summary_data');
                const normalizedPresenceProperties = {};

                if (company) {
                    // NOTE the use of posts in the dashboard means it is possible for
                    // presence to be unpopulated for brand new landscapes
                    presence = _.get(company.getPrimaryRecord(source), 'presence', {});
                    _.extend(normalizedPresenceProperties, {
                        presence_handle: _.get(presence, 'handle'),
                        presence_icon_url: _.get(presence, 'icon_url') || RivalIQ.utils.companyDisplay.getIcon(company.attributes),
                        presence_link: `/company/${company.id}`,
                        presence_name: company.get('name'),
                        companyAbbr: RivalIQ.utils.companyDisplay.getAbbreviation(company.attributes)
                    });
                } else {
                    _.extend(normalizedPresenceProperties, {
                        presence_handle: presence.handle,
                        presence_icon_url: presence.icon_url,
                        presence_link: '',
                        presence_name: presence.name
                    });
                }

                if (source === RivalIQ.enums.sources.TWITTER && normalizedPresenceProperties.presence_icon_url) {
                    normalizedPresenceProperties.presence_icon_url = normalizedPresenceProperties.presence_icon_url.replace(RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER].lowResImgSuffix, '');
                }

                const display = _.extend({
                    imageLarge: null
                }, me.get('display'), {
                    image: me.get('image')
                });

                return _.extend({}, me.attributes, {
                    channel: me.getChannel()
                }, normalizedPresenceProperties, display);
            }
        });

        models.DiscoveryPost = Backbone.Model.extend({
            getChannel: function () {
                const me = this;
                const channel = me.get('channel');
                return RivalIQ.data.channels.get(channel);
            }
        });
    }

}());
